<app-header-links [isCombinedApplication]="isCombinedApplication"></app-header-links>
<app-header-logo></app-header-logo>

<div class="app-content ps-margin-bottom-huge ps-padding-x-small">
  <div [hidden]="isLoading$ | async">
    <router-outlet></router-outlet>
  </div>

  <div [hidden]="(isLoading$ | async) === false">
    <ps-progress-spinner class="ps-spinner" diameter="48"></ps-progress-spinner>
  </div>
</div>

<app-footer [brand]="brand" [isCombinedApplication]="isCombinedApplication"></app-footer>
